import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConnectionService } from '../../../services/connection/connection.service';
import { DiscountCoupon } from '../models/discount-coupon';
import { DiscountService } from './discount.service';

@Injectable()
export class DiscountOdooService implements DiscountService {

  constructor(
    private connectionService: ConnectionService,
  ) { }

  getCouponDiscounts(
    coupons: string[],
    productIds: number[],
    prices: number[],
    quantities: number[],
    bookingDate: string,
    bookingFromTime: number,
    bookingToTime: number)
    : Observable<DiscountCoupon[]> {
    return this.connectionService.sendJsonPostRequest('/store/payment/get_coupon_discounts', {
      coupons,
      productIds,
      prices,
      quantities,
      bookingDate,
      bookingFromTime,
      bookingToTime
    }).pipe(map(
      result => {
        return result ? result.map(item => item ? DiscountCoupon.createFromAny(item) : null) : [];
      }));
  }

  getGuestCouponDiscounts(
    coupons: string[],
    productIds: number[],
    prices: number[],
    quantities: number[],
    bookingDate: string,
    bookingFromTime: number,
    bookingToTime: number)
    : Observable<DiscountCoupon[]> {
    return this.connectionService.sendJsonPostRequest('/store/payment/get-guest-coupon-discounts', {
      coupons,
      productIds,
      prices,
      quantities,
      bookingDate,
      bookingFromTime,
      bookingToTime
    }).pipe(map(
      result => {
        return result ? result.map(item => item ? DiscountCoupon.createFromAny(item) : null) : [];
      }));
  }
}
